import request from "../../network/request";

/**
 * 用户登录
 */
function loginapi(data) {
  return request.post('admin/login', data, {
    isauth: false,
    passerr: true,
  })
}

/**
 * 登录成功后,获取支部信息
 */
function getBranchInfoapi(data) {
  return request.post('/api/basePartyBrachInfo', data, {
    isauth: true,
    passerr: false
  })
}

/**
 * 登录成功后,获取登录用户信息
 */
function getInfoapi(data) {
  return request.post('admin/base/getUserInfo', data, {
    isauth: true,
    passerr: false
  })
}


/**
 * 登录成功后,获取支部版本
 */
function getVersionapi(data) {
  return request.post('/admin/getLastVersion', data, {
    isauth: false,
    passerr: false
  })
}



export {
  loginapi,
  getBranchInfoapi,
  getInfoapi,
  getVersionapi
}



// WEBPACK FOOTER //
// ./src/network/api/login.js